import React from "react"
import aboutData from "../../data/about.json"

const About = (props) => {
  return <div class="accordion-item">{aboutData.description}</div>
}

export default About
